import React, { Component } from "react";
import { Provider } from "react-redux";
import { MuiThemeProvider } from "@material-ui/core";
import Shell from "../ui/Shell/shell";
import configureStore from "./configureStore";
import sendError from "./sendError";
import theme from "../theme/theme";
import config from "./config";
import { livefeedservice } from "../services/Live";

function Loading(props) {
	return <div> Loading</div>;
}

export default class Setup extends Component {
	constructor(props) {
		console.log("\nStarted.. \n");

		super(props);

		this.state = {
			config: null,
			width: null,
			height: null,
			error: null
		};
	}

	componentDidCatch(error, info) {
		// catch DOM errors
		console.error(error);
		console.error(info.componentStack);

		sendError(
			this.state.config.store.getState(),
			{ payload: { message: error, stackTrace: info.componentStack } },
			"REACT DOM ERROR"
		);
		this.setState({ error: error + "\nAt:\n" + info.componentStack });
	}

	updateDimensions() {
		//trigger rerenders on screen size changes
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}
	componentWillMount() {
		this.updateDimensions();
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions.bind(this));
		configureStore().then(config => {
			//add post init logic here
			// livefeedservice.Start();
			this.setState({ config });
		});
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
		livefeedservice.Cleanup();
	}

	render() {
		if (this.state.error) {
			return <div>{config.debug && <pre style={{ padding: 30 }}>{this.state.error}</pre>}</div>;
		}

		return this.state.config ? (
			<Provider store={this.state.config.store}>
				<MuiThemeProvider theme={theme}>
					<Shell history={this.state.config.history} width={this.state.width} height={this.state.width} />
				</MuiThemeProvider>
			</Provider>
		) : (
			<Loading />
		);
	}
}



// WEBPACK FOOTER //
// ./src/boot/setup.js